<template>
  <el-dialog title="选择零件" width="75%" :append-to-body="true" :visible.sync="viewData.visible"
             :close-on-click-modal="false" v-loading="loading">
    <div class="user-settings">
      <div>
        <el-table :data="partList" row-key="id" size="small" :header-cell-style="{background:'#f5f5f5'}"
                  style="width: 100%;" border @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" header-align="left" align="left" width="50" label="序号">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="partCode" header-align="center" align="left" min-width="100" label="零件编码">
          </el-table-column>
          <el-table-column prop="partName" header-align="center" align="left" min-width="100" label="零件名称">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="confirm()">
        确认
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    basicFormData: Object,
  },
  data() {
    return {
      loading: false,
      viewData: {
        visible: false,
        width: ''
      },
      dataList: [],
      partList: [],
      rfqId: '',
      selectedParts: [], // 存储选中的零件
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
    }
  },
  methods: {
    open(partList, rfqId) {
      this.viewData.visible = true;
      this.partList = partList;
      this.rfqId = rfqId;
      console.log("进入后的零件数据", this.partList);
      this.dataListLoading = true;
      this.selectedParts = [];
    },
    cancel() {
      this.close();
    },
    close() {
      if (!this.viewData.visible) {
        return;
      }
      this.viewData.visible = false;
    },
    confirm() {
      if (this.selectedParts.length === 0) {
        this.$message({
          message: '请选择至少一条数据添加',
          type: 'warning'
        });
        return false;
      } else {
        console.log("选择的零件集合",this.selectedParts);
        this.$emit('selectParts', this.selectedParts);
        this.viewData.visible = false;
        this.selectedParts = [];
      }
    },
    handleSelectionChange(selection) {
      this.selectedParts = selection;
    },
  }
}
</script>

<style lang="scss">
.el-dialog__body {
  .org-dialog-form {
    width: 95%;
  }
}

.linetext {
  white-space: pre-line;
}

.el-table__body {
  tr.current-row > td {
    color: #fff;
    background-color: #409EFF !important;
  }
}

.fr {
  float: right;
}

.mt15 {
  margin-top: 15px;
}

.mb {
  margin-bottom: 15px;
}
</style>
